export enum ImageCategory {
  FABRIC = 'FABRIC',
  GRAPHIC = 'GRAPHIC',
}
